// import { Button, ImageList, ImageListItem } from "@mui/material";
// import Swiper from "./swiper";
// import Dishe from "../sections/dishe";
// import i18next, { t } from "i18next";
// import calories from "../../../images/Fire.svg";
// import time from "../../../images/Timer.svg";

// import {
//   getBadgeStatusClass,
//   getLocalStorageMenuItem,
//   ISDARKTHEME,
//   SARIconThemeColor,
//   setMobileBackColor,
//   setMobileButttonBackColor,
//   setMobileCardBorderColor,
//   setMobileCardColor,
//   setMobileTextColor,
// } from "../../../utility";
// import { Badge } from "react-bootstrap";
// import no_image from "../../../images/No_Image_Available.jpg";
// import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
// import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
// import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// const MianInfo = ({
//   item,
//   sympoleData,
//   selected,
//   calorie,
//   tableQr,
//   tableName,
//   updataItem,
//   favorites,
//   handleFavorite,
//   handleSelected,
//   open,
//   handleOrder,
//   order_ability,
//   treeData,
// }) => {

//   const [params, setParams] = useSearchParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const onImageError = (e) => {
//     e.target.src = no_image;
//   };


//   const openItem = (comboItem) => {
//     if (item.sold_out !== 1) {
//       if (location.pathname === `/${tableName}/${tableQr}/sections`) {
//         navigate(
//           `/${tableName}/${tableQr}/items?item=${comboItem?.id}&t=${params.get(
//             "t"
//           )}&selectedLang=${getLocalStorageMenuItem("lang")}`,
//           {
//             state: { from: location.pathname },
//           }
//         );
//       } else {

//         updataItem(comboItem);
//       }
//     }
//   };

//   return (
//     <div className={`min-vh-75`}>
//       <div className="head mt-4 px-3">
//         {item.label_name ? (
//           <p className="mb-2 alignByLang">
//             <Badge
//               className={` ${getBadgeStatusClass(
//                 item.label_name
//               )} p-2 font-size-12 sub-font m-1`}
//             >
//               {item.label_name || "New"}
//             </Badge>
//             {item?.sold_out !== 1 ? (
//               <Badge
//                 className={`${getLocalStorageMenuItem("theme") === "dark"
//                   ? "instock-badge-style-dark"
//                   : "instock-badge-style"
//                   }  p-2 font-size-12 sub-font m-1`}
//               >
//                 {t("in stock")}
//               </Badge>
//             ) : (
//               <Badge
//                 className={`${getLocalStorageMenuItem("theme") === "dark"
//                   ? "outofinstock-badge-style-dark"
//                   : "outofinstock-badge-style"
//                   }  p-2 font-size-12 sub-font m-1`}
//               >
//                 {t("Out of stock")}
//               </Badge>
//             )}
//           </p>
//         ) : (
//           <p className="mb-2 alignByLang">
//             <Badge
//               className={` ${getBadgeStatusClass(
//                 "New"
//               )} p-2 font-size-12 sub-font m-1`}
//             >
//               {t("New")}
//             </Badge>
//             {item?.sold_out !== 1 ? (
//               <Badge
//                 className={`${getLocalStorageMenuItem("theme") === "dark"
//                   ? "instock-badge-style-dark"
//                   : "instock-badge-style"
//                   }  p-2 font-size-12 sub-font m-1`}
//               >
//                 {t("in stock")}
//               </Badge>
//             ) : (
//               <Badge
//                 className={`${getLocalStorageMenuItem("theme") === "dark"
//                   ? "outofinstock-badge-style-dark"
//                   : "outofinstock-badge-style"
//                   }  p-2 font-size-12 sub-font m-1`}
//               >
//                 {t("Out of stock")}
//               </Badge>
//             )}
//           </p>
//         )}
//       </div>


//       {item?.has_price_option_item && item?.price_option_items?.length ? (
//         <div className="alignByLang">
//           <div
//             style={{ display: "flex", justifyContent: "space-between" }}
//             className="row px-3 m-0"
//           >
//             <div className="col-6 p-0">
//               <p
//                 className="fw-bold mt-3 font-size-22 head-font"
//                 style={{
//                   textAlign:
//                     getLocalStorageMenuItem("lang") === "ar" ||
//                       getLocalStorageMenuItem("lang") === "fa"
//                       ? "right"
//                       : "left",
//                 }}
//               >
//                 {item?.name}
//                 <br /> ({selected}){" "}
//               </p>
//             </div>
//             <div className="col-4 p-0">
//               <Swiper
//                 handleSelected={handleSelected}
//                 prices={item?.price_option_items}
//                 currency={sympoleData}
//               />
//             </div>
//           </div>
//         </div>
//       ) : item?.price_options?.length > 0 ? (
//         <div className="alignByLang">
//           <div
//             style={{ display: "flex", justifyContent: "space-between" }}
//             className="row px-3 m-0"
//           >
//             <div className="col-6 p-0">
//               <p
//                 className="fw-bold mt-3 font-size-22 head-font"
//                 style={{
//                   textAlign:
//                     getLocalStorageMenuItem("lang") === "ar" ||
//                       getLocalStorageMenuItem("lang") === "fa"
//                       ? "right"
//                       : "left",
//                 }}
//               >
//                 {item?.name}
//                 <br /> ({selected}){" "}
//               </p>
//             </div>
//             <div className="col-4 p-0">
//               <Swiper
//                 handleSelected={handleSelected}
//                 prices={item?.price_options}
//                 currency={sympoleData}
//               />
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="d-flex justify-content-between px-3 alignByLang">
//           <p
//             style={{ color: setMobileTextColor(), maxWidth: "70%" }}
//             className="font-size-22 head-font"
//           >
//             {item?.name}
//           </p>

//           <p
//             className="head-font"
//             style={{
//               color:
//                 getLocalStorageMenuItem("theme") === "costomize"
//                   ? setMobileTextColor()
//                   : "#6ba5f2",
//             }}
//           >
//             <span>
//               {item?.old_price > 0 && (
//                 <span
//                   style={{
//                     textDecoration: "line-through",
//                     color: "red",
//                   }}
//                 >
//                   {item.old_price || ""}
//                 </span>
//               )}{" "}
//               {item?.price} {sympoleData ? sympoleData === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympoleData : ""}
//             </span>
//           </p>
//         </div>
//       )}

//       <div className="contents px-3 alignByLang">
//         {item?.price_options?.length > 0 && calorie && calorie > 0 ? (
//           <span
//             className="fw-bold sub-font mr-1"
//             style={{ color: setMobileTextColor() }}
//           >
//             <img src={calories} className="mr-1 calories_style" />{" "}
//             {`${calorie ? calorie : 0} ${t("cal")}`}
//           </span>
//         ) : (
//           item?.calories &&
//           item?.calories > 0 &&
//           item?.price_options?.length === 0 && (
//             <span className={`head-font ${setMobileButttonBackColor()}`}>
//               <img src={calories} className="mr-1 calories_style" />{" "}
//               {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
//             </span>
//           )
//         )}

//         <span
//           className="head-font mr-1"
//           style={{ color: setMobileTextColor() }}
//         >
//           {(item?.max_preparation_time != null &&
//             item?.max_preparation_time >= 0) ||
//             (item?.min_preparation_time != null &&
//               item?.min_preparation_time >= 0) ? (
//             <img src={time} className="mr-1 timer_style" />
//           ) : (
//             ""
//           )}

//           {` ${item?.min_preparation_time === 0
//             ? item?.min_preparation_time
//             : !item?.min_preparation_time
//               ? ""
//               : item?.min_preparation_time
//             } ${(!item?.max_preparation_time && item?.max_preparation_time !== 0) ||
//               (!item?.min_preparation_time && item?.min_preparation_time !== 0)
//               ? ``
//               : `-`
//             }   ${item?.max_preparation_time === 0
//               ? item?.max_preparation_time
//               : !item?.max_preparation_time
//                 ? ""
//                 : item?.max_preparation_time
//             }

//           ${(item?.max_preparation_time != null &&
//               item?.max_preparation_time >= 0) ||
//               (item?.min_preparation_time != null &&
//                 item?.min_preparation_time >= 0)
//               ? t("min(s)") + " "
//               : ""
//             }
//           `}
//         </span>
//         {item?.description && (
//           <div className="mt-4">
//             <p
//               style={{ color: setMobileTextColor() }}
//               className="font-size-16 head-font mb-2"
//             >
//               {t("Description")}
//             </p>
//             <p
//               style={{ color: setMobileTextColor(), fontWeight: 400 }}
//               className="font-size-12 sub-font"
//             >
//               {" "}
//               {item?.description}
//             </p>
//           </div>
//         )}
//         <div className="mt-4">
//           {item?.warnings?.length > 1 && (
//             <p
//               style={{ color: setMobileTextColor() }}
//               className="font-size-16 head-font mb-2"
//             >
//               {t("warning ingredient")}
//             </p>
//           )}
//           <div className="col-12">
//             {item?.warnings?.map((element) => (
//               <span key={element.id} className="alignByLang">
//                 <span
//                   style={{ marginLeft: 2, marginRight: 5 }}
//                   className="font-size-18 sub-font"
//                 >

//                   <img
//                     style={{
//                       width: "32px",
//                       height: "32px",
//                       marginLeft: 2,
//                       marginRight: 5,
//                     }}
//                     src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element.icon_dark : element?.icon_light || element.icon}
//                     onError={onImageError}
//                     alt="icon"
//                   />
//                   {element.name}
//                 </span>
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>


//       {item?.is_combo_item && item?.comboItems?.length > 0 && (
//         <div className="mt-4 sub-font" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//           <h2 className="sub-font" style={{ marginBottom: '2px', fontSize: '1rem', color: setMobileCardBorderColor(), textAlign: 'center' }}>
//             {t("Combo Items")}
//           </h2>

//           <div
//             style={{
//               display: 'table',
//               width: '90%',
//               margin: '10px auto',
//               textAlign: 'center',
//             }}
//           >
//             {item?.comboItems?.map((comboItem, index) => (
//               <div
//                 className="sub-font alignByLang"
//                 key={index}
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'space-between',
//                   backgroundColor: setMobileCardBorderColor(),
//                   marginBottom: '10px',
//                   padding: '5px',
//                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                   borderRadius: '10px',
//                 }}

//                 onClick={() => openItem(comboItem)}
//               >
//                 <div
//                   style={{
//                     width: '80px',
//                     flexShrink: 0,
//                   }}
//                 >
//                   <img
//                     src={comboItem?.image || no_image}
//                     alt={t(item?.name)}
//                     style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
//                     onError={onImageError}

//                   />
//                 </div>
//                 <div style={{ flex: 1, textAlign: 'center' }}>
//                   <span className="sub-font" style={{ color: setMobileTextColor() }}>{t(comboItem?.name)}</span>
//                 </div>
//                 <div style={{ flex: 1, textAlign: 'center' }}>
//                   <span style={{ color: setMobileTextColor() }}>{comboItem?.quantity}</span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}





//       {item?.recommended_items?.length > 0 && (
//         <div
//           className={`footer mt-4 p-24 w-100 alignByLang ${getLocalStorageMenuItem("mode") === "dark"
//             ? "footer-dark"
//             : "footer-light"
//             }`}
//           style={{
//             color: setMobileTextColor(),
//             marginBottom: "62px",
//             borderBottom: "0px",
//             borderLeft: "0px",
//             borderRight: "0px",
//           }}
//         >
//           <div className="row">
//             <h2 style={{ color: setMobileTextColor() }} className="head-font">
//               <strong>{t("Suggested items")}</strong>
//             </h2>
//             <ImageList
//               sx={{
//                 gridAutoFlow: "column",
//                 gridTemplateColumns:
//                   "repeat(auto-fill,minmax(160px,1fr)) !important",
//                 gridAutoColumns: "minmax(160px, 1fr)",
//               }}
//             >
//               {item?.recommended_items.map(
//                 (element) =>
//                   item?.id !== element.id && (
//                     <ImageListItem
//                       className="me-3"
//                       key={element.id}
//                       interval={3000}
//                     >
//                       <Dishe
//                         item={element}
//                         updataItem={updataItem}
//                         // refetch={refetch}
//                         qrCode={tableQr}
//                         qrName={tableName}
//                         favorites={favorites}
//                         sympole={sympoleData}
//                         handleFavorite={handleFavorite}
//                         suggested={true}
//                       />
//                     </ImageListItem>
//                   )
//               )}
//             </ImageList>
//           </div>
//         </div>
//       )}

//       <div
//         className={`add-cart-button-containter`}
//         style={{ backgroundColor: setMobileBackColor(), padding: 15 }}
//       >
//         <span className={`heart cursor`} onClick={() => handleFavorite(item)}>
//           {favorites.findIndex((fav) => fav.id === item?.id) !== -1 ? (
//             <img
//               src={heart_full_active_svg}
//               className="heart"
//               style={{ width: "35px", height: "35px" }}
//               onError={onImageError}
//             />
//           ) : (
//             <img
//               src={heart_full_inactive_svg}
//               className="heart"
//               style={{ width: "35px", height: "35px" }}
//               onError={onImageError}
//             />
//           )}
//         </span>
//         {!treeData?.details?.order_ability && !treeData?.details?.whatsapp ? (
//           true
//         ) : (
//           <Button
//             className="btn text-center sub-font alignByLang mx-2"
//             style={{
//               backgroundColor: setMobileButttonBackColor(),
//               color: setMobileTextColor(),
//               width: "85%",
//               fontSize: "16px",
//               fontWeight: 600,
//               zIndex: 9999,
//               display: open ? "none" : "block",
//             }}
//             onClick={(e) => handleOrder(true,e)}
//           >
//             {t("Add to cart")}
//           </Button>
//         )}
//       </div>

//       <div></div>
//     </div>
//   );
// };

// export default MianInfo;



// import {
//   Button,
//   ImageList,
//   ImageListItem,
//   FormControl,
//   RadioGroup,
//   FormGroup,
//   TextareaAutosize,
//   TextField,
//   FormControlLabel,
//   Checkbox,
//   Box,
//   IconButton,
// } from "@mui/material";
// import { AddOutlined, RemoveOutlined } from "@mui/icons-material";
// import Swiper from "./swiper";
// import Dishe from "../sections/dishe";
// import i18next, { t } from "i18next";
// import calories from "../../../images/Fire.svg";
// import time from "../../../images/Timer.svg";
// import {
//   getBadgeStatusClass,
//   getLocalStorageMenuItem,
//   ISDARKTHEME,
//   SARIconThemeColor,
//   setMobileBackColor,
//   setMobileButttonBackColor,
//   setMobileCardBorderColor,
//   setMobileCardColor,
//   setMobileTextColor,
// } from "../../../utility";
// import { Badge } from "react-bootstrap";
// import no_image from "../../../images/No_Image_Available.jpg";
// import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
// import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
// import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// import { Form, Formik } from "formik";
// import { useMutation, useQueryClient } from "react-query";
// import axios from "axios";
// import { useState } from "react";
// import CheckModifier from "./checkModifier";
// import CheckModifiers from "./checkModifiers";

// const MianInfo = ({
//   item,
//   sympoleData,
//   selected,
//   calorie,
//   tableQr,
//   tableName,
//   updataItem,
//   favorites,
//   handleFavorite,
//   handleSelected,
//   open,
//   handleOrder,
//   order_ability,
//   treeData,
//   handleOpenToast
// }) => {
//   const [params, setParams] = useSearchParams();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const onImageError = (e) => {
//     e.target.src = no_image;
//   };

//   const [checked, setChecked] = useState(false);
//   const [qty, setQty] = useState(1);
//   const queryClient = useQueryClient();

//   const addItemFuction = async (values) => {
//     const { data: response } = await axios.post(
//       `${process.env.REACT_APP_API}/basket-items`,
//       values,
//       {
//         headers: {
//           localization: getLocalStorageMenuItem("lang"),
//         },
//       }
//     );
//     return response.data;
//   };

//   const { mutate, isLoading, isSuccess } = useMutation(addItemFuction, {
//     onSuccess: (res) => {
//       console.log("res",res)
//       console.log("res",res)
//       handleOpenToast(t("Order has been added successfully"), true);
//       if (!checked) {
//         setTimeout(() => {
//           navigate(
//             `/${tableName}/${tableQr}/sections?section=${params.get("section") ? params.get("section") : '0'}&t=${params.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
//           );
//         }, 1000);
//       } else {
//         setQty(1);
//       }
//     },
//     onError: (res) => {
//       handleOpenToast(t(res.response.data.message), false);
//     },
//     onSettled: () => {
//       queryClient.invalidateQueries("addToBasket");
//     },
//   });

//   const openItem = (comboItem) => {
//     if (item.sold_out !== 1) {
//       if (location.pathname === `/${tableName}/${tableQr}/sections`) {
//         navigate(
//           `/${tableName}/${tableQr}/items?item=${comboItem?.id}&t=${params.get(
//             "t"
//           )}&selectedLang=${getLocalStorageMenuItem("lang")}`,
//           {
//             state: { from: location.pathname },
//           }
//         );
//       } else {
//         updataItem(comboItem);
//       }
//     }
//   };

//   const customRadioStyles = {
//     "& .MuiRadio-root": {
//       color:
//         getLocalStorageMenuItem("theme") === "dark" ||
//           getLocalStorageMenuItem("theme") === "white"
//           ? "#6BA5F2"
//           : setMobileButttonBackColor(),
//     },
//   };

//   const customCheckStyles = {
//     color:
//       getLocalStorageMenuItem("theme") === "dark" ||
//         getLocalStorageMenuItem("theme") === "white"
//         ? "#6BA5F2"
//         : setMobileButttonBackColor(),
//   };

//   const modifiers =
//     item?.modifiers?.filter((element) => {
//       return element?.order_options.length > 0;
//     }) || [];

//   return (
//     <Formik
//       initialValues={{
//         table: params.get("t"),
//         item_id: item?.id,
//         modifiers: modifiers.map((element) => {
//           return {
//             id: element.group.id,
//             max: element.max,
//             min: element.min,
//             order_options: [],
//           };
//         }),
//         price_option: selected ? selected.id : null,
//         quantity: 1,
//         notes: "",
//         menu_code: tableQr,
//         price: selected ? selected.price : item?.price,
//         token: getLocalStorageMenuItem("gustToken"),
//         prevOptionPrice: 0,
//       }}
//       enableReinitialize
//       onSubmit={(values) => {
//         mutate(values);
//       }}
//     >
//       {({ errors, setFieldValue, values, resetForm }) => (
//         <Form className={`min-vh-75`}>
//           <div className="head mt-4 px-3">
//             {item.label_name ? (
//               <p className="mb-2 alignByLang">
//                 <Badge
//                   className={` ${getBadgeStatusClass(
//                     item.label_name
//                   )} p-2 font-size-12 sub-font m-1`}
//                 >
//                   {item.label_name || "New"}
//                 </Badge>
//                 {item?.sold_out !== 1 ? (
//                   <Badge
//                     className={`${getLocalStorageMenuItem("theme") === "dark"
//                         ? "instock-badge-style-dark"
//                         : "instock-badge-style"
//                       }  p-2 font-size-12 sub-font m-1`}
//                   >
//                     {t("in stock")}
//                   </Badge>
//                 ) : (
//                   <Badge
//                     className={`${getLocalStorageMenuItem("theme") === "dark"
//                         ? "outofinstock-badge-style-dark"
//                         : "outofinstock-badge-style"
//                       }  p-2 font-size-12 sub-font m-1`}
//                   >
//                     {t("Out of stock")}
//                   </Badge>
//                 )}
//               </p>
//             ) : (
//               <p className="mb-2 alignByLang">
//                 <Badge
//                   className={` ${getBadgeStatusClass(
//                     "New"
//                   )} p-2 font-size-12 sub-font m-1`}
//                 >
//                   {t("New")}
//                 </Badge>
//                 {item?.sold_out !== 1 ? (
//                   <Badge
//                     className={`${getLocalStorageMenuItem("theme") === "dark"
//                         ? "instock-badge-style-dark"
//                         : "instock-badge-style"
//                       }  p-2 font-size-12 sub-font m-1`}
//                   >
//                     {t("in stock")}
//                   </Badge>
//                 ) : (
//                   <Badge
//                     className={`${getLocalStorageMenuItem("theme") === "dark"
//                         ? "outofinstock-badge-style-dark"
//                         : "outofinstock-badge-style"
//                       }  p-2 font-size-12 sub-font m-1`}
//                   >
//                     {t("Out of stock")}
//                   </Badge>
//                 )}
//               </p>
//             )}
//           </div>

//           {item?.has_price_option_item && item?.price_option_items?.length ? (
//             <div className="alignByLang">
//               <div
//                 style={{ display: "flex", justifyContent: "space-between" }}
//                 className="row px-3 m-0"
//               >
//                 <div className="col-6 p-0">
//                   <p
//                     className="fw-bold mt-3 font-size-22 head-font"
//                     style={{
//                       textAlign:
//                         getLocalStorageMenuItem("lang") === "ar" ||
//                           getLocalStorageMenuItem("lang") === "fa"
//                           ? "right"
//                           : "left",
//                     }}
//                   >
//                     {item?.name}
//                     <br /> ({selected}){" "}
//                   </p>
//                 </div>
//                 <div className="col-4 p-0">
//                   <Swiper
//                     handleSelected={handleSelected}
//                     prices={item?.price_option_items}
//                     currency={sympoleData}
//                   />
//                 </div>
//               </div>
//             </div>
//           ) : item?.price_options?.length > 0 ? (
//             <div className="alignByLang">
//               <div
//                 style={{ display: "flex", justifyContent: "space-between" }}
//                 className="row px-3 m-0"
//               >
//                 <div className="col-6 p-0">
//                   <p
//                     className="fw-bold mt-3 font-size-22 head-font"
//                     style={{
//                       textAlign:
//                         getLocalStorageMenuItem("lang") === "ar" ||
//                           getLocalStorageMenuItem("lang") === "fa"
//                           ? "right"
//                           : "left",
//                     }}
//                   >
//                     {item?.name}
//                     <br /> ({selected}){" "}
//                   </p>
//                 </div>
//                 <div className="col-4 p-0">
//                   <Swiper
//                     handleSelected={handleSelected}
//                     prices={item?.price_options}
//                     currency={sympoleData}
//                   />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <div className="d-flex justify-content-between px-3 alignByLang">
//               <p
//                 style={{ color: setMobileTextColor(), maxWidth: "70%" }}
//                 className="font-size-22 head-font"
//               >
//                 {item?.name}
//               </p>

//               <p
//                 className="head-font"
//                 style={{
//                   color:
//                     getLocalStorageMenuItem("theme") === "costomize"
//                       ? setMobileTextColor()
//                       : "#6ba5f2",
//                 }}
//               >
//                 <span>
//                   {item?.old_price > 0 && (
//                     <span
//                       style={{
//                         textDecoration: "line-through",
//                         color: "red",
//                       }}
//                     >
//                       {item.old_price || ""}
//                     </span>
//                   )}{" "}
//                   {item?.price}{" "}
//                   {sympoleData ? (
//                     sympoleData === "SAR" ? (
//                       <img
//                         width={20}
//                         height={20}
//                         src={SARIconThemeColor()}
//                         className="mr-1"
//                       />
//                     ) : (
//                       sympoleData
//                     )
//                   ) : (
//                     ""
//                   )}
//                 </span>
//               </p>
//             </div>
//           )}

//           <div className="contents px-3 alignByLang">
//             {item?.price_options?.length > 0 && calorie && calorie > 0 ? (
//               <span
//                 className="fw-bold sub-font mr-1"
//                 style={{ color: setMobileTextColor() }}
//               >
//                 <img src={calories} className="mr-1 calories_style" />{" "}
//                 {`${calorie ? calorie : 0} ${t("cal")}`}
//               </span>
//             ) : (
//               item?.calories &&
//               item?.calories > 0 &&
//               item?.price_options?.length === 0 && (
//                 <span className={`head-font ${setMobileButttonBackColor()}`}>
//                   <img src={calories} className="mr-1 calories_style" />{" "}
//                   {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
//                 </span>
//               )
//             )}

//             <span
//               className="head-font mr-1"
//               style={{ color: setMobileTextColor() }}
//             >
//               {(item?.max_preparation_time != null &&
//                 item?.max_preparation_time >= 0) ||
//                 (item?.min_preparation_time != null &&
//                   item?.min_preparation_time >= 0) ? (
//                 <img src={time} className="mr-1 timer_style" />
//               ) : (
//                 ""
//               )}

//               {` ${item?.min_preparation_time === 0
//                   ? item?.min_preparation_time
//                   : !item?.min_preparation_time
//                     ? ""
//                     : item?.min_preparation_time
//                 } ${(!item?.max_preparation_time && item?.max_preparation_time !== 0) ||
//                   (!item?.min_preparation_time && item?.min_preparation_time !== 0)
//                   ? ``
//                   : `-`
//                 }    ${item?.max_preparation_time === 0
//                   ? item?.max_preparation_time
//                   : !item?.max_preparation_time
//                     ? ""
//                     : item?.max_preparation_time
//                 }

//               ${(item?.max_preparation_time != null &&
//                     item?.max_preparation_time >= 0) ||
//                   (item?.min_preparation_time != null &&
//                     item?.min_preparation_time >= 0)
//                   ? t("min(s)") + " "
//                   : ""
//                 }
//               `}
//             </span>
//             {item?.description && (
//               <div className="mt-4">
//                 <p
//                   style={{ color: setMobileTextColor() }}
//                   className="font-size-16 head-font mb-2"
//                 >
//                   {t("Description")}
//                 </p>
//                 <p
//                   style={{ color: setMobileTextColor(), fontWeight: 400 }}
//                   className="font-size-12 sub-font"
//                 >
//                   {" "}
//                   {item?.description}
//                 </p>
//               </div>
//             )}
//             <div className="mt-4">
//               {item?.warnings?.length > 1 && (
//                 <p
//                   style={{ color: setMobileTextColor() }}
//                   className="font-size-16 head-font mb-2"
//                 >
//                   {t("warning ingredient")}
//                 </p>
//               )}
//               <div className="col-12">
//                 {item?.warnings?.map((element) => (
//                   <span key={element.id} className="alignByLang">
//                     <span
//                       style={{ marginLeft: 2, marginRight: 5 }}
//                       className="font-size-18 sub-font"
//                     >
//                       <img
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           marginLeft: 2,
//                           marginRight: 5,
//                         }}
//                         src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element.icon_dark : element?.icon_light || element.icon}
//                         onError={onImageError}
//                         alt="icon"
//                       />
//                       {element.name}
//                     </span>
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {modifiers?.map((modifier) => (
//             <div key={modifier.group.id} className="m-top-12 px-3 alignByLang">
//               <div className="d-flex justify-content-between">
//                 <p
//                   className="head-font font-size-16"
//                   style={{ color: setMobileTextColor() }}
//                 >
//                   {modifier.group.name}{" "}
//                   <span
//                     className="sub-font font-size-16"
//                     style={{ color: setMobileTextColor() }}
//                   >
//                     {modifier.required === 1
//                       ? `(${t("Choose 1")})`
//                       : `(${t("Choose")} ${modifier.min} ${t("to")} ${modifier.max
//                       })`}
//                   </span>
//                 </p>
//                 {modifier.required === 1 && (
//                   <div>
//                     <Button
//                       variant="outlined"
//                       className="head-font font-size-12 new-badge-style"
//                       sx={{
//                         borderColor: setMobileButttonBackColor(),
//                         color: setMobileTextColor(),
//                       }}
//                     >
//                       {t("Require")}
//                     </Button>
//                   </div>
//                 )}
//               </div>
//               {modifier.required === 1 ? (
//                 <FormControl className="d-block">
//                   <RadioGroup
//                     row
//                     aria-labelledby="demo-row-radio-buttons-group-label"
//                     name="row-radio-buttons-group"
//                     className="d-block"
//                     onClick={(e) => {
//                       if (e.target.value) {
//                         const array = [...values.modifiers];
//                         const index = array.findIndex(
//                           (element) => element.id === modifier.group.id
//                         );
//                         if (index === -1) {
//                           const newModifier = {
//                             id: modifier.group.id,
//                             min: modifier.min,
//                             max: modifier.max,
//                             order_options: [JSON.parse(e.target.value).id],
//                           };
//                           array.push(newModifier);
//                           setFieldValue("modifiers", array);
//                           setFieldValue(
//                             "price",
//                             values.price + JSON.parse(e.target.value).price
//                           );
//                           setFieldValue(
//                             "prevOptionPrice",
//                             JSON.parse(e.target.value).price
//                           );
//                         } else {
//                           const newModifier = { ...array[index] };
//                           newModifier.order_options = [
//                             JSON.parse(e.target.value).id,
//                           ];
//                           array[index] = newModifier;
//                           setFieldValue("modifiers", array);
//                           setFieldValue(
//                             "price",
//                             values.price +
//                             JSON.parse(e.target.value).price -
//                             values.prevOptionPrice
//                           );
//                           setFieldValue(
//                             "prevOptionPrice",
//                             JSON.parse(e.target.value).price
//                           );
//                         }
//                       }
//                     }}
//                     sx={customRadioStyles}
//                   >
//                     <div className="sub-font">
//                       {modifier?.order_options.map((element) => (
//                         <CheckModifier
//                           key={element.id}
//                           order={element}
//                           currency={sympoleData}
//                           setFieldValue={setFieldValue}
//                           values={values}
//                           modifier={modifier}
//                           handleOpenToast={handleOpenToast}
//                         />
//                       ))}
//                     </div>
//                   </RadioGroup>
//                 </FormControl>
//               ) : (
//                 <FormGroup>
//                   <div className="sub-font">
//                     {" "}
//                     {modifier?.order_options.map((element) => (
//                       <CheckModifiers
//                         key={element.id}
//                         order={element}
//                         currency={sympoleData}
//                         setFieldValue={setFieldValue}
//                         values={values}
//                         modifier={modifier}
//                         handleOpenToast={handleOpenToast}
//                       />
//                     ))}
//                   </div>
//                 </FormGroup>
//               )}
//             </div>
//           ))}

//           <div className="m-top-12 px-3 alignByLang">
//             <label
//               htmlFor="quantity"
//               className="font-size-14 mb-1 sub-font"
//               style={{ color: setMobileTextColor() }}
//             >
//               {t("Quantity")}
//             </label>
//             <TextField
//               id="quantity"
//               name="quantity"
//               type="number"
//               inputProps={{
//                 min: 1,
//                 style: {
//                   color: setMobileTextColor(),
//                   backgroundColor: setMobileBackColor(),
//                   borderWidth: 1,
//                   borderColor: setMobileTextColor(),
//                   borderStyle: "solid",
//                   borderRadius: 4,
//                 },
//               }}
//               value={qty}
//               onChange={(e) => {
//                 setQty(e.target.value);
//                 setFieldValue("quantity", parseInt(e.target.value));
//               }}
//               className="form-control"
//               style={{
//                 backgroundColor: setMobileBackColor(),
//                 color: setMobileTextColor(),
//               }}
//             />
//           </div>

//           <div
//             className="m-top-12 px-3 alignByLang"
//             style={{
//               marginBottom: "75px",
//             }}
//           >
//             <label
//               htmlFor="notes"
//               className="font-size-14 mb-1 sub-font"
//               onClick={resetForm}
//               style={{ color: setMobileTextColor() }}
//             >
//               {t("Note")}
//             </label>
//             <TextareaAutosize
//               id="notes"
//               name="notes"
//               minRows={3}
//               className="form-control rounded-2 sub-font"
//               style={{
//                 resize: "none",
//                 backgroundColor: setMobileBackColor(),
//                 color: setMobileTextColor(),
//               }}
//               value={values.notes}
//               onChange={(e) => setFieldValue("notes", e.target.value)}
//               placeholder={t("Enter a note...")}
//               inputprops={{
//                 style: {
//                   color: setMobileTextColor(),
//                   backgroundColor: setMobileBackColor(),
//                 },
//               }}
//             />
//             <FormControlLabel
//               control={<Checkbox style={customCheckStyles} />}
//               className="mx-0 mt-2"
//               label={
//                 <span
//                   className="sub-font font-size-16"
//                   style={{ color: setMobileTextColor() }}
//                 >
//                   {t("Add and continue")}
//                 </span>
//               }
//               onChange={(e) => setChecked(e.target.checked)}
//             />
//           </div>

//           {item?.is_combo_item && item?.comboItems?.length > 0 && (
//             <div className="mt-4 sub-font" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <h2 className="sub-font" style={{ marginBottom: '2px', fontSize: '1rem', color: setMobileCardBorderColor(), textAlign: 'center' }}>
//                 {t("Combo Items")}
//               </h2>

//               <div
//                 style={{
//                   display: 'table',
//                   width: '90%',
//                   margin: '10px auto',
//                   textAlign: 'center',
//                 }}
//               >
//                 {item?.comboItems?.map((comboItem, index) => (
//                   <div
//                     className="sub-font alignByLang"
//                     key={index}
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'space-between',
//                       backgroundColor: setMobileCardBorderColor(),
//                       marginBottom: '10px',
//                       padding: '5px',
//                       boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                       borderRadius: '10px',
//                     }}

//                     onClick={() => openItem(comboItem)}
//                   >
//                     <div
//                       style={{
//                         width: '80px',
//                         flexShrink: 0,
//                       }}
//                     >
//                       <img
//                         src={comboItem?.image || no_image}
//                         alt={t(item?.name)}
//                         style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
//                         onError={onImageError}

//                       />
//                     </div>
//                     <div style={{ flex: 1, textAlign: 'center' }}>
//                       <span className="sub-font" style={{ color: setMobileTextColor() }}>{t(comboItem?.name)}</span>
//                     </div>
//                     <div style={{ flex: 1, textAlign: 'center' }}>
//                       <span style={{ color: setMobileTextColor() }}>{comboItem?.quantity}</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {item?.recommended_items?.length > 0 && (
//             <div
//               className={`footer mt-4 p-24 w-100 alignByLang ${getLocalStorageMenuItem("mode") === "dark"
//                   ? "footer-dark"
//                   : "footer-light"
//                 }`}
//               style={{
//                 color: setMobileTextColor(),
//                 marginBottom: "62px",
//                 borderBottom: "0px",
//                 borderLeft: "0px",
//                 borderRight: "0px",
//               }}
//             >
//               <div className="row">
//                 <h2 style={{ color: setMobileTextColor() }} className="head-font">
//                   <strong>{t("Suggested items")}</strong>
//                 </h2>
//                 <ImageList
//                   sx={{
//                     gridAutoFlow: "column",
//                     gridTemplateColumns:
//                       "repeat(auto-fill,minmax(160px,1fr)) !important",
//                     gridAutoColumns: "minmax(160px, 1fr)",
//                   }}
//                 >
//                   {item?.recommended_items.map(
//                     (element) =>
//                       item?.id !== element.id && (
//                         <ImageListItem
//                           className="me-3"
//                           key={element.id}
//                           interval={3000}
//                         >
//                           <Dishe
//                             item={element}
//                             updataItem={updataItem}
//                             qrCode={tableQr}
//                             qrName={tableName}
//                             favorites={favorites}
//                             sympole={sympoleData}
//                             handleFavorite={handleFavorite}
//                             suggested={true}
//                           />
//                         </ImageListItem>
//                       )
//                   )}
//                 </ImageList>
//               </div>
//             </div>
//           )}

//           <div
//             className={`add-cart-button-containter`}
//             style={{ backgroundColor: setMobileBackColor(), padding: 15 }}
//           >
//             <span className={`heart cursor`} onClick={() => handleFavorite(item)}>
//               {favorites.findIndex((fav) => fav.id === item?.id) !== -1 ? (
//                 <img
//                   src={heart_full_active_svg}
//                   className="heart"
//                   style={{ width: "35px", height: "35px" }}
//                   onError={onImageError}
//                 />
//               ) : (
//                 <img
//                   src={heart_full_inactive_svg}
//                   className="heart"
//                   style={{ width: "35px", height: "35px" }}
//                   onError={onImageError}
//                 />
//               )}
//             </span>
//             {!treeData?.details?.order_ability && !treeData?.details?.whatsapp ? (
//               true
//             ) : (
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="space-between"
//                 style={{
//                   backgroundColor: setMobileButttonBackColor(),
//                   padding: "8px",
//                   borderRadius: "8px",
//                   width: "85%",
//                 }}
//               >
//                 <IconButton
//                   onClick={() => {
//                     const newQty = qty - 1;
//                     if (newQty > 0) {
//                       setQty(newQty);
//                       setFieldValue("quantity", newQty);
//                     }
//                   }}
//                   size="small"
//                   style={{
//                     backgroundColor: setMobileButttonBackColor(),
//                     color: setMobileTextColor(),
//                   }}
//                   disabled={qty <= 1}
//                 >
//                   <RemoveOutlined />
//                 </IconButton>

//                 <span
//                   style={{
//                     margin: "0 8px",
//                     color: setMobileTextColor(),
//                   }}
//                 >
//                   |
//                 </span>

//                 <Button
//                   className="rounded-2 sub-font"
//                   style={{
//                     backgroundColor: setMobileButttonBackColor(),
//                     color: setMobileTextColor(),
//                     fontSize: "16px",
//                     fontWeight: 600,
//                     width: "100%",
//                     border: "none",
//                   }}
//                   type="submit"
//                 >
//                   {t("Add to cart")}
//                 </Button>

//                 <span
//                   style={{
//                     margin: "0 8px",
//                     color: setMobileTextColor(),
//                   }}
//                 >
//                   |
//                 </span>

//                 <IconButton
//                   onClick={() => {
//                     const newQty = qty + 1;
//                     setQty(newQty);
//                     setFieldValue("quantity", newQty);
//                   }}
//                   size="small"
//                   style={{
//                     backgroundColor: setMobileButttonBackColor(),
//                     color: setMobileTextColor(),
//                   }}
//                 >
//                   <AddOutlined />
//                 </IconButton>
//               </Box>
//             )}
//           </div>
//         </Form>
//       )}
//     </Formik>
//   );
// };

// export default MianInfo;


import {
  Button,
  ImageList,
  ImageListItem,
  FormControl,
  RadioGroup,
  FormGroup,
  TextareaAutosize,
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { AddOutlined, RemoveOutlined } from "@mui/icons-material";
import Swiper from "./swiper";
import Dishe from "../sections/dishe";
import i18next, { t } from "i18next";
import calories from "../../../images/Fire.svg";
import time from "../../../images/Timer.svg";
import {
  getBadgeStatusClass,
  getLocalStorageMenuItem,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../../../utility";
import { Badge } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useState } from "react";
import CheckModifier from "./checkModifier";
import CheckModifiers from "./checkModifiers";

const MianInfo = ({
  item,
  sympoleData,
  selected,
  calorie,
  tableQr,
  tableName,
  updataItem,
  favorites,
  handleFavorite,
  handleSelected,
  open,
  handleOrder,
  order_ability,
  treeData,
  handleOpenToast
}) => {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const onImageError = (e) => {
    e.target.src = no_image;
  };

  const [checked, setChecked] = useState(false);
  const [qty, setQty] = useState(1);
  const queryClient = useQueryClient();

  const addItemFuction = async (values) => {
    const { data: response } = await axios.post(
      `${process.env.REACT_APP_API}/basket-items`,
      values,
      {
        headers: {
          localization: getLocalStorageMenuItem("lang"),
        },
      }
    );
    return response.data;
  };

  const { mutate, isLoading, isSuccess } = useMutation(addItemFuction, {
    onSuccess: (res) => {
      handleOpenToast(t("Order has been added successfully"), true);
      if (!checked) {
        setTimeout(() => {
          navigate(
            `/${tableName}/${tableQr}/sections?section=${params.get("section") ? params.get("section") : '0'}&t=${params.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
          );
        }, 1000);
      } else {
        setQty(1);
      }
    },
    onError: (res) => {
      handleOpenToast(t(res.response.data.message), false);
    },
    onSettled: () => {
      queryClient.invalidateQueries("addToBasket");
    },
  });

  const openItem = (comboItem) => {
    if (item.sold_out !== 1) {
      if (location.pathname === `/${tableName}/${tableQr}/sections`) {
        navigate(
          `/${tableName}/${tableQr}/items?item=${comboItem?.id}&t=${params.get(
            "t"
          )}&selectedLang=${getLocalStorageMenuItem("lang")}`,
          {
            state: { from: location.pathname },
          }
        );
      } else {
        updataItem(comboItem);
      }
    }
  };

  const customRadioStyles = {
    "& .MuiRadio-root": {
      color:
        getLocalStorageMenuItem("theme") === "dark" ||
          getLocalStorageMenuItem("theme") === "white"
          ? "#6BA5F2"
          : setMobileButttonBackColor(),
    },
  };

  const customCheckStyles = {
    color:
      getLocalStorageMenuItem("theme") === "dark" ||
        getLocalStorageMenuItem("theme") === "white"
        ? "#6BA5F2"
        : setMobileButttonBackColor(),
  };

  const modifiers =
    item?.modifiers?.filter((element) => {
      return element?.order_options.length > 0;
    }) || [];

  return (
    <Formik
      initialValues={{
        table: params.get("t"),
        item_id: item?.id,
        modifiers: modifiers.map((element) => {
          return {
            id: element.group.id,
            max: element.max,
            min: element.min,
            order_options: [],
          };
        }),
        price_option: selected ? selected.id : null,
        quantity: 1,
        notes: "",
        menu_code: tableQr,
        price: selected ? selected.price : item?.price,
        token: getLocalStorageMenuItem("gustToken"),
        prevOptionPrice: 0,
      }}
      enableReinitialize
      onSubmit={(values) => {
        mutate(values);
      }}
    >
      {({ errors, setFieldValue, values, resetForm }) => (
        <Form className={`min-vh-75`}>
          <div className="head mt-4 px-3">
            {item.label_name ? (
              <p className="mb-2 alignByLang">
                <Badge
                  className={` ${getBadgeStatusClass(
                    item.label_name
                  )} p-2 font-size-12 sub-font m-1`}
                >
                  {item.label_name || "New"}
                </Badge>
                {item?.sold_out !== 1 ? (
                  <Badge
                    className={`${getLocalStorageMenuItem("theme") === "dark"
                      ? "instock-badge-style-dark"
                      : "instock-badge-style"
                      }  p-2 font-size-12 sub-font m-1`}
                  >
                    {t("in stock")}
                  </Badge>
                ) : (
                  <Badge
                    className={`${getLocalStorageMenuItem("theme") === "dark"
                      ? "outofinstock-badge-style-dark"
                      : "outofinstock-badge-style"
                      }  p-2 font-size-12 sub-font m-1`}
                  >
                    {t("Out of stock")}
                  </Badge>
                )}
              </p>
            ) : (
              <p className="mb-2 alignByLang">
                <Badge
                  className={` ${getBadgeStatusClass(
                    "New"
                  )} p-2 font-size-12 sub-font m-1`}
                >
                  {t("New")}
                </Badge>
                {item?.sold_out !== 1 ? (
                  <Badge
                    className={`${getLocalStorageMenuItem("theme") === "dark"
                      ? "instock-badge-style-dark"
                      : "instock-badge-style"
                      }  p-2 font-size-12 sub-font m-1`}
                  >
                    {t("in stock")}
                  </Badge>
                ) : (
                  <Badge
                    className={`${getLocalStorageMenuItem("theme") === "dark"
                      ? "outofinstock-badge-style-dark"
                      : "outofinstock-badge-style"
                      }  p-2 font-size-12 sub-font m-1`}
                  >
                    {t("Out of stock")}
                  </Badge>
                )}
              </p>
            )}
          </div>

          {item?.has_price_option_item && item?.price_option_items?.length ? (
            <div className="alignByLang">
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                className="row px-3 m-0"
              >
                <div className="col-6 p-0">
                  <p
                    className="fw-bold mt-3 font-size-22 head-font"
                    style={{
                      textAlign:
                        getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                          ? "right"
                          : "left",
                    }}
                  >
                    {item?.name}
                    <br /> ({selected}){" "}
                  </p>
                </div>
                <div className="col-4 p-0">
                  <Swiper
                    handleSelected={handleSelected}
                    prices={item?.price_option_items}
                    currency={sympoleData}
                  />
                </div>
              </div>
            </div>
          ) : item?.price_options?.length > 0 ? (
            <div className="alignByLang">
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                className="row px-3 m-0"
              >
                <div className="col-6 p-0">
                  <p
                    className="fw-bold mt-3 font-size-22 head-font"
                    style={{
                      textAlign:
                        getLocalStorageMenuItem("lang") === "ar" ||
                          getLocalStorageMenuItem("lang") === "fa"
                          ? "right"
                          : "left",
                    }}
                  >
                    {item?.name}
                    <br /> ({selected}){" "}
                  </p>
                </div>
                <div className="col-4 p-0">
                  <Swiper
                    handleSelected={handleSelected}
                    prices={item?.price_options}
                    currency={sympoleData}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between px-3 alignByLang">
              <p
                style={{ color: setMobileTextColor(), maxWidth: "70%" }}
                className="font-size-22 head-font"
              >
                {item?.name}
              </p>

              <p
                className="head-font"
                style={{
                  color:
                    getLocalStorageMenuItem("theme") === "costomize"
                      ? setMobileTextColor()
                      : "#6ba5f2",
                }}
              >
                <span>
                  {item?.old_price > 0 && (
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "red",
                      }}
                    >
                      {item.old_price || ""}
                    </span>
                  )}{" "}
                  {item?.price}{" "}
                  {sympoleData ? (
                    sympoleData === "SAR" ? (
                      <img
                        width={20}
                        height={20}
                        src={SARIconThemeColor()}
                        className="mr-1"
                      />
                    ) : (
                      sympoleData
                    )
                  ) : (
                    ""
                  )}
                </span>
              </p>
            </div>
          )}

          <div className="contents px-3 alignByLang">
            {item?.price_options?.length > 0 && calorie && calorie > 0 ? (
              <span
                className="fw-bold sub-font mr-1"
                style={{ color: setMobileTextColor() }}
              >
                <img src={calories} className="mr-1 calories_style" />{" "}
                {`${calorie ? calorie : 0} ${t("cal")}`}
              </span>
            ) : (
              item?.calories &&
              item?.calories > 0 &&
              item?.price_options?.length === 0 && (
                <span className={`head-font ${setMobileButttonBackColor()}`}>
                  <img src={calories} className="mr-1 calories_style" />{" "}
                  {`${item?.calories ? item?.calories : 0} ${t("cal")}`}
                </span>
              )
            )}

            <span
              className="head-font mr-1"
              style={{ color: setMobileTextColor() }}
            >
              {(item?.max_preparation_time != null &&
                item?.max_preparation_time >= 0) ||
                (item?.min_preparation_time != null &&
                  item?.min_preparation_time >= 0) ? (
                <img src={time} className="mr-1 timer_style" />
              ) : (
                ""
              )}

              {` ${item?.min_preparation_time === 0
                ? item?.min_preparation_time
                : !item?.min_preparation_time
                  ? ""
                  : item?.min_preparation_time
                } ${(!item?.max_preparation_time && item?.max_preparation_time !== 0) ||
                  (!item?.min_preparation_time && item?.min_preparation_time !== 0)
                  ? ``
                  : `-`
                }    ${item?.max_preparation_time === 0
                  ? item?.max_preparation_time
                  : !item?.max_preparation_time
                    ? ""
                    : item?.max_preparation_time
                }
              
              ${(item?.max_preparation_time != null &&
                  item?.max_preparation_time >= 0) ||
                  (item?.min_preparation_time != null &&
                    item?.min_preparation_time >= 0)
                  ? t("min(s)") + " "
                  : ""
                }
              `}
            </span>
            {item?.description && (
              <div className="mt-4">
                <p
                  style={{ color: setMobileTextColor() }}
                  className="font-size-16 head-font mb-2"
                >
                  {t("Description")}
                </p>
                <p
                  style={{ color: setMobileTextColor(), fontWeight: 400 }}
                  className="font-size-12 sub-font"
                >
                  {" "}
                  {item?.description}
                </p>
              </div>
            )}
            <div className="mt-4">
              {item?.warnings?.length > 1 && (
                <p
                  style={{ color: setMobileTextColor() }}
                  className="font-size-16 head-font mb-2"
                >
                  {t("warning ingredient")}
                </p>
              )}
              <div className="col-12">
                {item?.warnings?.map((element) => (
                  <span key={element.id} className="alignByLang">
                    <span
                      style={{ marginLeft: 2, marginRight: 5 }}
                      className="font-size-18 sub-font"
                    >
                      <img
                        style={{
                          width: "32px",
                          height: "32px",
                          marginLeft: 2,
                          marginRight: 5,
                        }}
                        src={ISDARKTHEME(getLocalStorageMenuItem("theme") || treeData?.details?.mobile_settings?.theme, setMobileBackColor() || treeData?.details?.mobile_settings?.colorProps?.back) ? element.icon_dark : element?.icon_light || element.icon}
                        onError={onImageError}
                        alt="icon"
                      />
                      {element.name}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>

          {modifiers?.map((modifier) => (
            <div key={modifier.group.id} className="m-top-12 px-3 alignByLang">
              <div className="d-flex justify-content-between">
                <p
                  className="head-font font-size-16"
                  style={{ color: setMobileTextColor() }}
                >
                  {modifier.group.name}{" "}
                  <span
                    className="sub-font font-size-16"
                    style={{ color: setMobileTextColor() }}
                  >
                    {modifier.required === 1
                      ? `(${t("Choose 1")})`
                      : `(${t("Choose")} ${modifier.min} ${t("to")} ${modifier.max
                      })`}
                  </span>
                </p>
                {modifier.required === 1 && (
                  <div>
                    <Button
                      variant="outlined"
                      className="head-font font-size-12 new-badge-style"
                      sx={{
                        borderColor: setMobileButttonBackColor(),
                        color: setMobileTextColor(),
                      }}
                    >
                      {t("Require")}
                    </Button>
                  </div>
                )}
              </div>
              {modifier.required === 1 ? (
                <FormControl className="d-block">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    className="d-block"
                    onClick={(e) => {
                      if (e.target.value) {
                        const array = [...values.modifiers];
                        const index = array.findIndex(
                          (element) => element.id === modifier.group.id
                        );
                        if (index === -1) {
                          const newModifier = {
                            id: modifier.group.id,
                            min: modifier.min,
                            max: modifier.max,
                            order_options: [JSON.parse(e.target.value).id],
                          };
                          array.push(newModifier);
                          setFieldValue("modifiers", array);
                          setFieldValue(
                            "price",
                            values.price + JSON.parse(e.target.value).price
                          );
                          setFieldValue(
                            "prevOptionPrice",
                            JSON.parse(e.target.value).price
                          );
                        } else {
                          const newModifier = { ...array[index] };
                          newModifier.order_options = [
                            JSON.parse(e.target.value).id,
                          ];
                          array[index] = newModifier;
                          setFieldValue("modifiers", array);
                          setFieldValue(
                            "price",
                            values.price +
                            JSON.parse(e.target.value).price -
                            values.prevOptionPrice
                          );
                          setFieldValue(
                            "prevOptionPrice",
                            JSON.parse(e.target.value).price
                          );
                        }
                      }
                    }}
                    sx={customRadioStyles}
                  >
                    <div className="sub-font">
                      {modifier?.order_options.map((element) => (
                        <CheckModifier
                          key={element.id}
                          order={element}
                          currency={sympoleData}
                          setFieldValue={setFieldValue}
                          values={values}
                          modifier={modifier}
                          handleOpenToast={handleOpenToast}
                        />
                      ))}
                    </div>
                  </RadioGroup>
                </FormControl>
              ) : (
                <FormGroup>
                  <div className="sub-font">
                    {" "}
                    {modifier?.order_options.map((element) => (
                      <CheckModifiers
                        key={element.id}
                        order={element}
                        currency={sympoleData}
                        setFieldValue={setFieldValue}
                        values={values}
                        modifier={modifier}
                        handleOpenToast={handleOpenToast}
                      />
                    ))}
                  </div>
                </FormGroup>
              )}
            </div>
          ))}

          <div
            className="m-top-12 px-3 alignByLang"
            style={{
              marginBottom: "75px",
            }}
          >
            <label
              htmlFor="notes"
              className="font-size-14 mb-1 sub-font"
              onClick={resetForm}
              style={{ color: setMobileTextColor() }}
            >
              {t("Note")}
            </label>
            <TextareaAutosize
              id="notes"
              name="notes"
              minRows={3}
              className="form-control rounded-2 sub-font"
              style={{
                resize: "none",
                backgroundColor: setMobileBackColor(),
                color: setMobileTextColor(),
              }}
              value={values.notes}
              onChange={(e) => setFieldValue("notes", e.target.value)}
              placeholder={t("Enter a note...")}
              inputprops={{
                style: {
                  color: setMobileTextColor(),
                  backgroundColor: setMobileBackColor(),
                },
              }}
            />
            <FormControlLabel
              control={<Checkbox style={customCheckStyles} />}
              className="mx-0 mt-2"
              label={
                <span
                  className="sub-font font-size-16"
                  style={{ color: setMobileTextColor() }}
                >
                  {t("Add and continue")}
                </span>
              }
              onChange={(e) => setChecked(e.target.checked)}
            />
          </div>

          {item?.is_combo_item && item?.comboItems?.length > 0 && (
            <div className="mt-4 sub-font" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <h2 className="sub-font" style={{ marginBottom: '2px', fontSize: '1rem', color: setMobileCardBorderColor(), textAlign: 'center' }}>
                {t("Combo Items")}
              </h2>

              <div
                style={{
                  display: 'table',
                  width: '90%',
                  margin: '10px auto',
                  textAlign: 'center',
                }}
              >
                {item?.comboItems?.map((comboItem, index) => (
                  <div
                    className="sub-font alignByLang"
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      backgroundColor: setMobileCardBorderColor(),
                      marginBottom: '10px',
                      padding: '5px',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      borderRadius: '10px',
                    }}

                    onClick={() => openItem(comboItem)}
                  >
                    <div
                      style={{
                        width: '80px',
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={comboItem?.image || no_image}
                        alt={t(item?.name)}
                        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '5px' }}
                        onError={onImageError}

                      />
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <span className="sub-font" style={{ color: setMobileTextColor() }}>{t(comboItem?.name)}</span>
                    </div>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <span style={{ color: setMobileTextColor() }}>{comboItem?.quantity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {item?.recommended_items?.length > 0 && (
            <div
              className={`footer mt-4 p-24 w-100 alignByLang ${getLocalStorageMenuItem("mode") === "dark"
                ? "footer-dark"
                : "footer-light"
                }`}
              style={{
                color: setMobileTextColor(),
                marginBottom: "62px",
                borderBottom: "0px",
                borderLeft: "0px",
                borderRight: "0px",
              }}
            >
              <div className="row">
                <h2 style={{ color: setMobileTextColor() }} className="head-font">
                  <strong>{t("Suggested items")}</strong>
                </h2>
                <ImageList
                  sx={{
                    gridAutoFlow: "column",
                    gridTemplateColumns:
                      "repeat(auto-fill,minmax(160px,1fr)) !important",
                    gridAutoColumns: "minmax(160px, 1fr)",
                  }}
                >
                  {item?.recommended_items.map(
                    (element) =>
                      item?.id !== element.id && (
                        <ImageListItem
                          className="me-3"
                          key={element.id}
                          interval={3000}
                        >
                          <Dishe
                            item={element}
                            updataItem={updataItem}
                            qrCode={tableQr}
                            qrName={tableName}
                            favorites={favorites}
                            sympole={sympoleData}
                            handleFavorite={handleFavorite}
                            suggested={true}
                          />
                        </ImageListItem>
                      )
                  )}
                </ImageList>
              </div>
            </div>
          )}

          <div
            className={`add-cart-button-containter`}
            style={{
              backgroundColor: setMobileBackColor(),
              padding: 15,
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
            }}
          >
            <span className={`heart cursor`} style={{ justifyContent: "center",alignSelf:"center" }} onClick={() => handleFavorite(item)}>
              {favorites.findIndex((fav) => fav.id === item?.id) !== -1 ? (
                <img
                  src={heart_full_active_svg}
                  className="heart"
                  style={{ width: "45px", height: "35px" }}
                  onError={onImageError}
                />
              ) : (
                <img
                  src={heart_full_inactive_svg}
                  className="heart"
                  style={{ width: "45px", height: "35px" }}
                  onError={onImageError}
                />
              )}
            </span>
            {!treeData?.details?.order_ability && !treeData?.details?.whatsapp ? (
              true
            ) : (
              // <Box
              //   display="flex"
              //   alignItems="center"
              //   justifyContent="space-between"
              //   style={{
              //     backgroundColor: setMobileButttonBackColor(),
              //     padding: "8px",
              //     borderRadius: "8px",
              //     width: "85%",
              //   }}
              // >
              //   <IconButton
              //     onClick={() => {
              //       const newQty = qty - 1;
              //       if (newQty > 0) {
              //         setQty(newQty);
              //         setFieldValue("quantity", newQty);
              //       }
              //     }}
              //     size="small"
              //     style={{
              //       backgroundColor: setMobileButttonBackColor(),
              //       color: setMobileTextColor(),
              //     }}
              //     disabled={qty <= 1}
              //   >
              //     <RemoveOutlined />
              //   </IconButton>

              //   <Typography
              //     variant="body1"
              //     style={{
              //       color: setMobileTextColor(),
              //       minWidth: '30px',
              //       textAlign: 'center'
              //     }}
              //   >
              //     {qty}
              //   </Typography>
              //   <IconButton
              //     onClick={() => {
              //       const newQty = qty + 1;
              //       setQty(newQty);
              //       setFieldValue("quantity", newQty);
              //     }}
              //     size="small"
              //     style={{
              //       backgroundColor: setMobileButttonBackColor(),
              //       color: setMobileTextColor(),
              //     }}
              //   >
              //     <AddOutlined />
              //   </IconButton>

              //   <Button
              //     className="rounded-2 sub-font"
              //     style={{
              //       backgroundColor: setMobileButttonBackColor(),
              //       color: setMobileTextColor(),
              //       fontSize: "16px",
              //       fontWeight: 600,
              //       flex: 1,
              //       margin: '0 8px',
              //       border: "none",
              //     }}
              //     type="submit"
              //     disabled={isLoading}
              //   >
              //     {isLoading ? t("Loading...") : t("Add to cart")}
              //   </Button>


              // </Box>

              <Box
                display="flex"
                alignItems="center"
                gap={1.5}
                sx={{
                  backgroundColor: setMobileButttonBackColor(),
                  borderRadius: 3,
                  p: 1,
                  width: "90%",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                {/* Quantity Controls */}
                <Box
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.08)",
                    borderRadius: 2,
                    px: 0.5,
                    py: 0.25,
                  }}
                >
                  <IconButton
                    onClick={() => {
                      const newQty = qty - 1;
                      if (newQty > 0) {
                        setQty(newQty);
                        setFieldValue("quantity", newQty);
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileTextColor(),
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                    }}
                    disabled={qty <= 1}
                  >
                    <RemoveOutlined fontSize="small" />
                  </IconButton>

                  <Typography
                    variant="body1"
                    sx={{
                      color: setMobileTextColor(),
                      fontWeight: 600,
                      minWidth: 32,
                      textAlign: "center",
                    }}
                  >
                    {qty}
                  </Typography>

                  <IconButton
                    onClick={() => {
                      const newQty = qty + 1;
                      setQty(newQty);
                      setFieldValue("quantity", newQty);
                    }}
                    size="small"
                    sx={{
                      backgroundColor: setMobileButttonBackColor(),
                      color: setMobileTextColor(),
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
                    }}
                  >
                    <AddOutlined fontSize="small" />
                  </IconButton>
                </Box>

                {/* Add to Cart Button */}
                <Button
                  variant="contained"
                  disableElevation
                  sx={{
                    flex: 1,
                    backgroundColor: setMobileButttonBackColor(),
                    color: setMobileTextColor(),
                    fontSize: "0.95rem",
                    fontWeight: 600,
                    borderRadius: 2,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.15)",
                    },
                  }}
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? t("Loading...") : t("Add to cart")}
                </Button>
              </Box>

            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default MianInfo;

